import { useQuery } from '@tanstack/react-query';
import { supplierService, Supplier } from '@/services/supplierService';

export const useSuppliers = () => {
  return useQuery({
    queryKey: ['suppliers'],
    queryFn: () => supplierService.getAll().then(res => res.data),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
};

export const useSupplier = (id: number) => {
  return useQuery({
    queryKey: ['suppliers', id],
    queryFn: () => supplierService.getById(id).then(res => res.data),
    enabled: !!id,
  });
};

export const useSupplierSearch = (search: string, limit: number = 20) => {
  return useQuery({
    queryKey: ['suppliers', 'search', search, limit],
    queryFn: () => supplierService.search(search, limit).then(res => res.data),
    staleTime: 30 * 1000, // 30 seconds for search results
    placeholderData: (previousData) => previousData, // Keep previous data while fetching
  });
};

// Export the type for use in components
export type { Supplier };
